import { Col, Form, Row } from 'antd';
import { Link } from 'react-router-dom';
import { PATHS } from '@routing/routes';
import { CheckCircleFilled } from '@ant-design/icons';
export const ResetPasswordConfirmation = () => {
  return (
    <div className="App">
      <Form name="senderForm" layout="vertical">
        <Row justify="center" align="middle">
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <br />
            <h3 className="center-text textColor normal-font">
              Password successfully updated.
              <br />
              <br />
              <span className="checkSignupConfirmationIcon">
                {' '}
                <CheckCircleFilled />
              </span>
              <br />
              <br />
              <Link to={PATHS.Login.path} className="normal-font center-text fs16px">
                <u>Click here to log in and book a pick up.</u>
              </Link>
            </h3>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
